document.addEventListener('DOMContentLoaded', async function() {
  let applyBtn = document.querySelector("#apply-discount-btn");
  let discountCode = document.querySelector("#discount-code-value");
  let discountCodeInput = document.querySelector("#discount-code");
  let discountCodeLabel = document.querySelector("#discount-code-label");
  let discountCodeStatus = document.querySelector("#discount-code-status");
  let discountCouponBlock = document.querySelector('#discount-coupon-block');
  let discountCouponOriginalPrice = document.querySelector('#discount-coupon__original-price');
  let discountCouponDiscountPrice = document.querySelector('#discount-coupon__discount-price');

  let applyBtnText = applyBtn.querySelector('.apply-btn-text');
  if (window.matchMedia("(max-width: 700px)").matches) {
    applyBtnText.innerHTML = btn_text_mobile;
  }

  // Graphql vars
  const checkoutCreate = () => `
    mutation checkoutCreate($input: CheckoutCreateInput!) {
      checkoutCreate(input: $input) {
        checkout {
          id
        }
        checkoutUserErrors {
          message
        }
        queueToken
      }
    }`;

  const checkoutDiscountCodeApplyV2 = () => `
    mutation checkoutDiscountCodeApplyV2($checkoutId: ID!, $discountCode: String!) {
      checkoutDiscountCodeApplyV2(checkoutId: $checkoutId, discountCode: $discountCode) {
        checkout {
          totalPrice {
            amount
          }
          discountApplications(first: 10) {
            nodes {
              value {
                ... on PricingPercentageValue {
                  percentage
                }
                ... on MoneyV2 {
                  amount
                }
              }
            }
          }
          shippingDiscountAllocations {
            allocatedAmount {
              amount
            }
          }
        }
        checkoutUserErrors {
          message
          field
          code
        }
      }
    }`;

  const checkoutLineItemsReplace = () => `
  mutation checkoutLineItemsReplace($checkoutId: ID!, $lineItems: [CheckoutLineItemInput!]!) {
    checkoutLineItemsReplace(checkoutId: $checkoutId, lineItems: $lineItems) {
      checkout {
        totalPrice {
          amount
        }
        discountApplications(first: 10) {
          nodes {
            value {
              ... on PricingPercentageValue {
                percentage
              }
              ... on MoneyV2 {
                amount
              }
            }
          }
        }
      }
      userErrors {
        field
        message
      }
    }
  }`

  const checkoutDiscountCodeRemove = () => `
    mutation checkoutDiscountCodeRemove($checkoutId: ID!) {
      checkoutDiscountCodeRemove(checkoutId: $checkoutId) {
        checkout {
          totalPrice {
            amount
            currencyCode
          }
        }
        checkoutUserErrors {
          message
          field
          code
        }
      }
    }`;

  const getProductByHandle = () => `
    query getProductByHandle($handle: String!) {
    product(handle: $handle) {
      variants(first: 10) {
        nodes {
          id
          title
          compareAtPrice {
            amount
          }
          price {
            amount
          }
        }
      }
    }
  }`

  const getMetaobject = () => `
    query getMetaobject($handle: MetaobjectHandleInput) {
      metaobject(handle: $handle) {
        fields {
          key
          value
          type
        }
      }
    }`
  // end

  let original_product_prices = getOriginalProductPriceValues();

  let checkoutId = createCheckout();

  applyBtn.addEventListener("click", function(e) {
    let coupon = discountCodeInput.value.trim().toUpperCase();
    coupon === '' ? showError() : applyDiscount(coupon);
  });

  discountCodeInput.addEventListener('keyup', function(event) {
    if (event.keyCode === 13) {
        applyBtn.click();
    }
    if (this.value.trim().length == 0) {
      removeError();
    }
  });

  function applyDiscount(code) {
    let apply_btn_initial_text = applyBtnText.innerHTML;
    applyBtnText.innerHTML = "<div class='loader'></div>";
    applyBtn.style.pointerEvents = "none";
    let is_referral = code.startsWith("RF") || code.startsWith("PF");

    try {
      if (discountCouponBlock.visible && !is_referral) {
        removeCoupon();
      }

      if (is_referral && $('#referral-code-block').is(':visible')) {
        removeCoupon();
      }

      let discount_data = applyCoupon(code);

      if (discount_data == null) {
        showError();
      } else {
        if (is_referral) {
          showReferralCode(code);
        } else {
          let coupon_info = getCouponInfo(code);
          if (Object.keys(coupon_info).length === 0)
            showError();
          else {
            if (!coupon_info.has_discount_percentage && coupon_info.free_month) {
              showFirstMonthFreeDiscountCoupon(code);
            } else {
              let discounted_price = calculateDiscount(discount_data['percentage'], discount_data['amount']);
              showDiscountCoupon(coupon_info, discounted_price);
            }
          }
        }
      }

    } catch (error) {
      console.log(error);
      showError();
    } finally {
      applyBtn.style.pointerEvents = "auto";
      applyBtnText.innerHTML = apply_btn_initial_text;
    }

  }

  function showError() {
    discountCodeStatus.removeAttribute("hidden");
    discountCodeStatus.innerHTML = discount_coupon_error;
    discountCodeInput.style.border = "1px solid #D96B6B";
    discountCodeLabel.classList.add('discount-code-error');
  }

  function removeError() {
    discountCodeStatus.setAttribute("hidden", true);
    discountCodeStatus.innerHTML = "";
    discountCodeLabel.classList.remove('discount-code-error');
    discountCodeInput.style.border = "";
  }

  function getSelectedVariantInfo() {
    let originalPrice, salePrice, variantId;

    if ($("[id$='-Fixed 12']").prop('checked')) {
      originalPrice = original_product_prices['priceFixed12'] * 1.24;
      salePrice = original_product_prices['salePriceFixed12'] * 1.24;
      variantId = original_product_prices['Fixed12'];
    }
    else if ($("[id$='-Fixed 24']").prop('checked')) {
      originalPrice = original_product_prices['priceFixed24'] * 1.24;
      salePrice = original_product_prices['salePriceFixed24'] * 1.24;
      variantId = original_product_prices['Fixed24'];
    } else {
      originalPrice = original_product_prices['priceFlex'] * 1.24;
      salePrice = original_product_prices['salePriceFlex'] * 1.24;
      variantId = original_product_prices['Flex'];
    }

    return [parseFloat(originalPrice).toFixed(2), parseFloat(salePrice).toFixed(2), variantId];
  }

  function calculateDiscount(percentage, amount) {
    let originalPrice = getSelectedVariantInfo()[0];

    let discount = percentage != null ? originalPrice * ( 1 - (percentage/100) ) : originalPrice - amount;
    let discounted_price = `${discount.toFixed(2)}€`.replace('.', ',');

    dispatchCouponEvent("coupon:added", discount);
    return discounted_price
  }

  function dispatchCouponEvent(event, discount) {
    let form = document.forms[discountCodeInput.dataset.form].id;
    let [originalPrice, salePrice, variantId] = getSelectedVariantInfo();
    if (event === "coupon:removed") {
      originalPrice = (originalPrice / 1.24).toFixed(2);
      salePrice = (salePrice / 1.24).toFixed(2);
    }
    form.dispatchEvent(new CustomEvent(event, {
      bubbles: true,
      detail: {
        discountedPrice: discount.toFixed(2),
        originalPrice: originalPrice,
        salePrice: salePrice,
        variantId: variantId
      }
    }));
  }

  function getOriginalProductPriceValues() {
    let product_prices_info = {};
    let handle = discountCodeInput.dataset.handle;
    let data = JSON.stringify({query: getProductByHandle(), variables: {"handle": handle}});

    $.ajax({
      method: 'POST',
      url: GRAPHQL_URL,
      async: false,
      dataType: 'json',
      headers: {'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN},
      data: data,
      contentType: 'application/json',
      success: function (result) {
        if ('data' in result && result.data.product != null) {
          for (let i=0; i < result.data.product.variants.nodes.length; i++) {
            let node = result.data.product.variants.nodes[i];
            let option = '';
            if (node.title.includes('Fixed 12')){
              option = 'Fixed12';
            } else if (node.title.includes('Fixed 24')){
              option = 'Fixed24';
            } else {
              option = 'Flex';
            }
            product_prices_info[`salePrice${option}`] = node.price.amount;
            product_prices_info[`price${option}`] = node.compareAtPrice != null ? node.compareAtPrice.amount : node.price.amount ;
            product_prices_info[option] = node.id;
          }
        }
      },
      error: function(result) {
        console.log(result);
      }
    });

    return product_prices_info;
  }

  function getCouponInfo(code) {
    let data = JSON.stringify({
      query: getMetaobject(),
      variables: {"handle": {"handle": code, "type": "discount_coupons_info"}}
    });
    let coupon_info = {};

    $.ajax({
      method: 'POST',
      url: GRAPHQL_URL,
      async: false,
      dataType: 'json',
      headers: {'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN},
      data: data,
      contentType: 'application/json',
      success: function (result) {
        if ('data' in result && result.data.metaobject != null) {
          let fields = result.data.metaobject.fields;
          for (let i=0; i<fields.length; i++) {
            coupon_info[fields[i]['key']] = fields[i]['type'] === 'boolean' ? fields[i]['value'] === 'true' : fields[i]['value'];
          }
        }
      },
      error: function(result) {
        console.log(result);
      }
    });

    return coupon_info;
  }

  function showDiscountCoupon(coupon_info, discounted_price) {
    removeError();
    discountCodeInput.value = "";
    discountCode.innerHTML = coupon_info.coupon;

    let coupon_descriptive_text = coupon_descriptive_text_percentage.replace('{{ discount }}',
        `${coupon_info.discount_percentage}${coupon_info.has_discount_percentage ? '%' : '€'}`).replace(
            '{{ duration }}', coupon_info.duration);
    if (coupon_info.free_month) coupon_descriptive_text += coupon_descriptive_text_free_month;
    document.getElementById('descriptive_text').innerText = coupon_descriptive_text;

    let originalPrice = getSelectedVariantInfo()[0];

    discountCouponOriginalPrice.innerText = `${originalPrice}€`.replace('.', ',');
    discountCouponDiscountPrice.innerText = discounted_price + " " + per_month_text;
    discountCouponBlock.classList.add('active');
    discountCouponBlock.style.height = 'auto';

    var height = discountCouponBlock.clientHeight + 'px';

    discountCouponBlock.style.height = '0px';

    setTimeout(function () {
        discountCouponBlock.style.height = height;
    }, 0);

    document.querySelector("#coupon__remove").addEventListener("click", removeDiscount);
    document.forms[discountCodeInput.dataset.form]?.addEventListener("variant:change", couponUpdateOnVariantChange);

  }

  function showFirstMonthFreeDiscountCoupon(code) {
    removeError();
    discountCodeInput.value = "";
    discountCode.innerHTML = code;

    discountCouponOriginalPrice.innerText = '';
    document.getElementById('descriptive_text').innerText = "";

    dispatchCouponEvent("coupon:removed", 0);

    discountCouponDiscountPrice.innerText = first_month_free_text;

    discountCouponBlock.classList.add('active');
    discountCouponBlock.style.height = 'auto';

    var height = discountCouponBlock.clientHeight + 'px';

    discountCouponBlock.style.height = '0px';

    setTimeout(function () {
        discountCouponBlock.style.height = height;
    }, 0);

    document.querySelector("#coupon__remove").addEventListener("click", removeDiscount);
  }

  function couponUpdateOnVariantChange() {
    if (discountCode.innerHTML in ["", "1FREE"] ||
        discountCode.innerHTML.startsWith("RF") ||
        discountCode.innerHTML.startsWith("PF"))
      return;

    let discount_data = replaceCheckoutProduct();
    if (discount_data === null)
      removeDiscount();
    else {
      discountCouponDiscountPrice.innerText = calculateDiscount(discount_data['percentage'], discount_data['amount']) + " " + per_month_text;
      discountCouponOriginalPrice.innerText = `${getSelectedVariantInfo()[0]}€`.replace('.', ',');
    }
  }

  // B2B enabled case
  // const b2bToggleSwitch = document.querySelector('.b2b-switch input[type="checkbox"]');
  // b2bToggleSwitch.addEventListener('click', function (){
  //   if (b2bToggleSwitch.checked === true) {
  //     let couponElVisible = false
  //     removeDiscount(couponElVisible);
  //   }
  // });

  /**
   * Coupons are always hidden in B2B mode
   * @param {boolean} couponElVisible - indicates if the coupon html element is visible during the removal action
   * default is false because b2b is always enabled
   */
  function removeDiscount(couponElVisible = false) {
    removeCoupon();
    dispatchCouponEvent("coupon:removed", 0);
    document.forms[discountCodeInput.dataset.form]?.removeEventListener("variant:change", couponUpdateOnVariantChange);

    discountCouponBlock.style.height = '0px';

    if (couponElVisible){
      discountCouponBlock.addEventListener('transitionend', function () {
        discountCouponBlock.classList.remove('active');
      }, {
        once: true
      });
    } else {
      discountCouponBlock.classList.remove('active');
    }

    discountCodeInput.value = "";
    discountCode.innerHTML = "";
    discountCouponOriginalPrice.innerText = "";
    discountCouponDiscountPrice.innerText = "";
    document.getElementById('descriptive_text').innerText = "";
  }

  function showReferralCode(code) {
    removeError();
    discountCodeInput.value = "";

    var referralCode = document.querySelector('#referral-code-value');
    referralCode.innerHTML = code;

    let referralCodeInfo = document.querySelector('#referral-code-info');
    if (code.startsWith('RF')) {
      referralCodeInfo.classList.remove('krs-code-info');
      referralCodeInfo.classList.add('coupon-discount-details--discount-price');
      $("#referral_disclaimer").show();
      referralCodeInfo.innerText = referral_code_info;
    } else {
      referralCodeInfo.classList.add('krs-code-info');
      referralCodeInfo.classList.remove('coupon-discount-details--discount-price');
      $("#referral_disclaimer").hide();
      referralCodeInfo.innerText = code.includes('1') ? krs_for_info : krs_giftcard_info;
    }

    let referralCodeBlock = document.querySelector('#referral-code-block');
    referralCodeBlock.classList.add('active');
    referralCodeBlock.style.height = 'auto';

    var height = referralCodeBlock.clientHeight + 'px';

    referralCodeBlock.style.height = '0px';

    setTimeout(function () {
        referralCodeBlock.style.height = height;
    }, 0);

    let remove_referral_btn = document.querySelector("#referral__remove");
    remove_referral_btn.addEventListener("click", function(e) {
      removeCoupon();

      referralCodeBlock.style.height = '0px';

      referralCodeBlock.addEventListener('transitionend', function () {
          referralCodeBlock.classList.remove('active');
      }, {
          once: true
      });

      discountCodeInput.value = "";
      referralCode.innerHTML = "";
      referralCodeInfo.innerText = "";

    });
  }

  function createCheckout() {
    var variant_id = getSelectedVariantInfo()[2];
    let variables = {
      "input": {
        "allowPartialAddresses": true,
        "buyerIdentity": {
          "countryCode": "GR"
        },
        "email": "testing@finloup.com",
        "lineItems": [
          {
            "quantity": 1,
            "variantId": variant_id
          }
        ],
        "note": "",
        "shippingAddress": {
          "address1": "",
          "address2": "",
          "city": "Athens",
          "company": "",
          "country": "Greece",
          "firstName": "",
          "lastName": "",
          "phone": "",
          "province": "",
          "zip": ""
        }
      },
    };

    let data = JSON.stringify({query: checkoutCreate(), variables: variables});

    let checkoutId = null;
    $.ajax({
      method: 'POST',
      url: GRAPHQL_URL,
      async: false,
      dataType: 'json',
      headers: {'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN},
      data: data,
      contentType: 'application/json',
      success: function (result) {
        if ('data' in result && result.data.checkoutCreate.checkout != null){
          checkoutId = result.data.checkoutCreate.checkout.id;
        } else {
          console.log(result);
        }
      },
      error: function(result) {
        console.log(result);
      }
    });

    return checkoutId;

  }

  function replaceCheckoutProduct() {
    let data = JSON.stringify({query: checkoutLineItemsReplace(),
      variables: {"checkoutId": checkoutId,"lineItems": {"quantity": 1, "variantId": getSelectedVariantInfo()[2]}}});
    let discount_data = {};

    $.ajax({
      method: 'POST',
      url: GRAPHQL_URL,
      async: false,
      dataType: 'json',
      headers: {'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN},
      data: data,
      contentType: 'application/json',
      success: function (result) {
        if ('data' in result && result.data.checkoutLineItemsReplace.userErrors.length === 0 && result.data.checkoutLineItemsReplace.checkout.discountApplications.nodes.length > 0) {
          discount_data['discounted_price'] = result.data.checkoutLineItemsReplace.checkout.totalPrice.amount;
          discount_data['percentage'] = null;
          discount_data['amount'] = null;

          let discounts = result.data.checkoutLineItemsReplace.checkout.discountApplications.nodes;
          for (let i=0; i < discounts.length; i++) {
            if ('percentage' in discounts[i].value && discounts[i].value.percentage !== 100)
              discount_data['percentage'] = discounts[i].value.percentage;
            if ('amount' in discounts[i].value)
              discount_data['amount'] = discounts[i].value.amount;
          }
        } else {
          console.log(result);
          discount_data = null;
        }
      },
      error: function(result) {
        console.log(result);
        discount_data = null;
      }
    })

    return discount_data;
  }

  function applyCoupon(code) {
    let data = JSON.stringify({query: checkoutDiscountCodeApplyV2(), variables: {"checkoutId": checkoutId, "discountCode": code}});
    let discount_data = {};

    $.ajax({
      method: 'POST',
      url: GRAPHQL_URL,
      async: false,
      dataType: 'json',
      headers: {'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN},
      data: data,
      contentType: 'application/json',
      success: function (result) {
        if ('data' in result && result.data.checkoutDiscountCodeApplyV2.checkout.discountApplications.nodes.length > 0 &&
            (result.data.checkoutDiscountCodeApplyV2.checkoutUserErrors.length === 0 ||
                result.data.checkoutDiscountCodeApplyV2.checkoutUserErrors[0].code === "HIGHER_VALUE_DISCOUNT_APPLIED")) {
          discount_data['discounted_price'] = result.data.checkoutDiscountCodeApplyV2.checkout.totalPrice.amount;
          discount_data['percentage'] = null;
          discount_data['amount'] = null;

          let discounts = result.data.checkoutDiscountCodeApplyV2.checkout.discountApplications.nodes;
          for (let i=0; i < discounts.length; i++) {
            if ('percentage' in discounts[i].value && discounts[i].value.percentage !== 100)
              discount_data['percentage'] = discounts[i].value.percentage;
            if ('amount' in discounts[i].value)
              discount_data['amount'] = discounts[i].value.amount;
          }
        } else {
          console.log(result);
          discount_data = null;
        }
      },
      error: function(result) {
        console.log(result);
        discount_data = null;
      }
    })

    return discount_data;
  }

  function removeCoupon() {
    let data = JSON.stringify({query: checkoutDiscountCodeRemove(), variables: {"checkoutId": checkoutId}});

    $.ajax({
      method: 'POST',
      url: GRAPHQL_URL,
      async: false,
      dataType: 'json',
      headers: {'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN},
      data: data,
      contentType: 'application/json',
      success: function (result) {
      },
      error: function(result) {
        console.log(result);
      }
    });

  }

});
